import { Injectable, Inject } from '@angular/core';
import { Observable, Subject, map } from 'rxjs';
import { IdentificationType } from '../../../shared/models/common/identification-type.model';
import { Country } from '../../../shared/models/common/country.model';
import { BaseService } from '../../../shared/services/base.service';
@Injectable({
    providedIn: 'root'
})
export class IdentificationTypesService extends BaseService<IdentificationType> {

    private serviceMessage: { severity: string, summary: string, detail?: string } | null = null;

    setServiceMessage(message: { severity: string, summary: string, detail?: string }) {
        this.serviceMessage = message;
    }

    showServiceMessage() {
        if (this.serviceMessage) {
            this.messageService.add(this.serviceMessage);
            this.serviceMessage = null; // limpiar despu�s de mostrar
            // Lo dejamos solo 5 seg
            setTimeout(() => {
                this.messageService.clear();
            }, 6000)
        }
    }

    getAllIdentificationTypes(): Observable<IdentificationType[]> {
        return this.http.get<IdentificationType[]>(`/api/IdentificationTypes`);
    }

    getIdentificationType(id: number): Observable<IdentificationType> {
        return this.http.get<IdentificationType>(`/api/IdentificationTypes`, {
            params: { id: id }
        });
    }

    deleteIdentificationType(identificationType: IdentificationType): Observable<void> {

        const result$ = new Subject<void>();

        this.http.delete<IdentificationType>(`/api/IdentificationTypes`, {

            params: { id: identificationType.id }

        }).subscribe({

            next: (data) => {
                this.setServiceMessage({ severity: 'success', summary: this.translateService.instant('identification_types.remove_success') });
                result$.next();  // Notificamos al componente que todo sali� bien
                result$.complete();
            },

            error: (error) => {
                this.setServiceMessage({ severity: 'error', summary: this.translateService.instant('general.error'), detail: error.error.message })
                result$.error(error);
            }

        });

        return result$.asObservable();

    }

    saveIdentificationType(identificationType: IdentificationType): Observable<void> {

        const result$ = new Subject<void>();

        if (identificationType.id) {

            this.http.put<IdentificationType>(`/api/IdentificationTypes`, identificationType).subscribe({

                next: (data) => {
                    this.setServiceMessage({ severity: 'success', summary: this.translateService.instant('identification_types.modified_success') });
                    result$.next();  // Notificamos al componente que todo sali� bien
                    result$.complete();
                },

                error: (error) => {
                    this.setServiceMessage({ severity: 'error', summary: this.translateService.instant('general.error'), detail: error.error.message })
                    result$.error(error);
                }

            });

        } else {
            this.http.post<IdentificationType>(`/api/IdentificationTypes`, identificationType).subscribe({

                next: (data) => {
                    this.messageService.add({ severity: 'success', summary: this.translateService.instant('identification_types.created_success') });
                    result$.next();  // Notificamos al componente que todo sali� bien
                    result$.complete();
                },

                error: (error) => {
                    this.messageService.add({ severity: 'error', summary: this.translateService.instant('general.error'), detail: error.error.message })
                    result$.error(error);
                }

            });
        }

        return result$.asObservable();

    }


    getAllCountries(): Observable<Country[]> {
        return this.http.get<{ rows: Country[] }>(`/api/Countries`).pipe(
            map(response => response.rows)
        );
    }
     


}
